import React from 'react';
import { ChefHat, Award, Leaf } from 'lucide-react';
import whyChooseUsImage from '../images/why_choose_us.jpg';

export default function WhyChooseUs() {
  const features = [
    {
      icon: ChefHat,
      title: "Certified & Expert Chefs",
      description: "Our meals are crafted by UAE-certified chefs with deep knowledge of sports nutrition. Every dish is designed to maximize performance — without compromising on taste."
    },
    {
      icon: Award,
      title: "Premium Quality Ingredients",
      description: "We source only the freshest, locally available produce and premium proteins. No preservatives, no shortcuts — just clean, nutrient-dense food delivered to your door."
    },
    {
      icon: Leaf,
      title: "Locally Sourced Produce",
      description: "We partner with trusted UAE farms and suppliers to bring you seasonal, fresh ingredients that support your fitness goals while reducing our environmental footprint."
    }
  ];

  return (
    <div className="bg-gray-100 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-800 leading-tight">
                Best Catering Services in Dubai
              </h2>

              <h3 className="text-xl font-semibold text-green-600 mb-6">
                Why choose us?
              </h3>

              <p className="text-gray-600 text-sm leading-relaxed">
                DailyFit is Dubai's leading healthy meal delivery service, trusted by athletes, professionals,
                and families across the UAE. We combine nutritional science with culinary excellence to
                deliver chef-prepared, macro-balanced meals — fresh to your doorstep every morning.
              </p>
            </div>

            {/* Features */}
            <div className="space-y-4">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div
                    key={index}
                    className="flex gap-4 items-start"
                  >
                    <div className="flex-shrink-0">
                      <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center">
                        <Icon className="w-4 h-4 text-white" />
                      </div>
                    </div>
                    <div className="space-y-2">
                      <h4 className="text-base font-semibold text-green-600">
                        {feature.title}
                      </h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-lg">
              <img
                src={whyChooseUsImage}
                alt="Happy people enjoying healthy food"
                className="w-full h-[500px] object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}